var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion" }, [
    _c(
      "div",
      {
        class: [_vm.opened ? "opened_class" : "closed_class", "header"],
        style: _vm.color
      },
      [
        _c("div", { staticClass: "btn", on: { click: _vm.openOrClose } }, [
          !_vm.opened
            ? _c("img", {
                attrs: { src: require("@/assets/icons/chevron_right_icon.svg") }
              })
            : _c("img", {
                attrs: { src: require("@/assets/icons/chevron_down_icon.svg") }
              })
        ]),
        _c("div", { staticClass: "conteudo-header" }, [_vm._t("header")], 2)
      ]
    ),
    _vm.opened
      ? _c("div", { staticClass: "body" }, [_vm._t("body")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }